"use strict";
var __read = (this && this.__read) || function (o, n) {
    var m = typeof Symbol === "function" && o[Symbol.iterator];
    if (!m) return o;
    var i = m.call(o), r, ar = [], e;
    try {
        while ((n === void 0 || n-- > 0) && !(r = i.next()).done) ar.push(r.value);
    }
    catch (error) { e = { error: error }; }
    finally {
        try {
            if (r && !r.done && (m = i["return"])) m.call(i);
        }
        finally { if (e) throw e.error; }
    }
    return ar;
};
var __spreadArray = (this && this.__spreadArray) || function (to, from) {
    for (var i = 0, il = from.length, j = to.length; i < il; i++, j++)
        to[j] = from[i];
    return to;
};
Object.defineProperty(exports, "__esModule", { value: true });
exports.format = void 0;
/* eslint-disable no-var */
var store_1 = require("../store/store");
function format(formatString) {
    var args = [];
    for (var _i = 1; _i < arguments.length; _i++) {
        args[_i - 1] = arguments[_i];
    }
    return String._toFormattedString(!1, __spreadArray([formatString], __read(args)));
}
exports.format = format;
/* from MSAjax */
String._toFormattedString = function (n, t) {
    for (var u = "", e = t[0], i = 0;;) {
        var o = e.indexOf("{", i);
        var f = e.indexOf("}", i);
        if (o < 0 && f < 0) {
            u += e.slice(i);
            break;
        }
        if (f > 0 && (f < o || o < 0)) {
            u += e.slice(i, f + 1);
            i = f + 2;
            continue;
        }
        u += e.slice(i, o);
        i = o + 1;
        if (e.charAt(i) === "{") {
            u += "{";
            i++;
            continue;
        }
        if (f < 0) {
            break;
        }
        var s = e.substring(i, f);
        var h = s.indexOf(":");
        var l = parseInt(h < 0 ? s : s.substring(0, h), 10) + 1;
        var c = h < 0 ? "" : s.substring(h + 1);
        var r = t[l];
        if (typeof r === "undefined" || r === null) {
            r = "";
        }
        u += r.toFormattedString ?
            r.toFormattedString(c) :
            n && r.localeFormat ?
                r.localeFormat(c) :
                r.format ?
                    r.format(c) :
                    r.toLocaleString(store_1.default.currentLocale || "en-US");
        i = f + 1;
    }
    return u;
};
